import { Subject } from 'rxjs';

export const gcpManualError$: Subject<Error> = new Subject<Error>();
